import { create } from "zustand";

const useUserData = create((set) => ({
    user: {},
    setUsetData: (data) => set((state) => ({ user: { ...state.user, ...data } })),
    removeUserData: () => set((state) => ({ user: {} })),
}));

export default useUserData;
